import { createContext } from 'react'
import { LoggedInUser } from 'shared/types/user'

type GifId = string | number
export type UserContextProps = {
    user: LoggedInUser
    isLoggedIn: boolean
    favorites: GifId[]
    localFavorites: GifId[]
    addFavorite(id: GifId): void
    removeFavorite(id: GifId): void
    hasFetchedFavorites: boolean
}

const UserContext = createContext({
    user: {} as LoggedInUser,
    localFavorites: [],
    favorites: [],
    isLoggedIn: false,
    hasFetchedFavorites: false,
    addFavorite: (_: GifId) => {
        console.error(`UserContext not initilized ${location.pathname}`)
    },
    removeFavorite: (_: GifId) => {
        console.error(`UserContext not initilized ${location.pathname}`)
    },
} as UserContextProps)

export default UserContext
